export const styles = {
  root: {
    width: '90%',
    margin: 'auto',
    maxWidth: 1200,
    flexGrow: 1,
  },
  title: {
    color: '#000'
  },
  subText: {
    color: '#666666',
  },
  stepper: {
    maxWidth: 1200,
    margin: '0 auto',
    backgroundColor: '#fff'
  }
}